import { render, staticRenderFns } from "./PaymentFailedUsedId.vue?vue&type=template&id=4d99aaf6&scoped=true&"
import script from "./PaymentFailedUsedId.vue?vue&type=script&lang=js&"
export * from "./PaymentFailedUsedId.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFailedUsedId.vue?vue&type=style&index=0&id=4d99aaf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d99aaf6",
  null
  
)

export default component.exports